import { PaymentAPI, PreparePaymentOptions } from '../../typings/Payment'
import {
  PreparePaymentPreparePaymentDocument,
  PreparePaymentPreparePaymentMutation,
  PreparePaymentPreparePaymentMutationVariables,
} from '../../graphql'

const preparePayment = async (paymentAPI: PaymentAPI, { paymentId, paymentMethodType }: PreparePaymentOptions) => {
  const { data, errors } = (await paymentAPI.apolloClient.mutate<
    PreparePaymentPreparePaymentMutation,
    PreparePaymentPreparePaymentMutationVariables
  >({
    mutation: PreparePaymentPreparePaymentDocument,
    variables: { paymentId, paymentMethodType },
  })) as { data?: PreparePaymentPreparePaymentMutation; errors?: Array<Error> }

  if (errors && errors.length > 0) {
    throw new Error(errors.map((e) => e.message).join('\n'))
  }

  if (!data) {
    throw new Error('Missing confirm payment data')
  }

  if (data.preparePayment.__typename === 'ExpectedErrors') {
    return { error: data.preparePayment.errors.map((e) => e.message).join('\n') }
  }

  return { data: data.preparePayment }
}

export default preparePayment
